import React from 'react';

function Button({ children, variant, size, className }) {
  return <button className={className}>{children}</button>
}

export default Button
